import { isIn } from "seneca-common/utils/functions";

import Parent, { ParentType } from "../../models/state/Parent";
import {
  actionTypes as bundleActionTypes,
  reducer as studentParentsReducer
} from "../../reduxBundle";

export default function parentReducer(
  state: ParentType = new Parent(),
  action: Record<string, any>
) {
  if (isIn(action.type, bundleActionTypes)) {
    // @ts-ignore
    return studentParentsReducer(state, action);
  }

  return state;
}
